import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

@Pipe({
	name: 'filterUniqueQuestion',
	pure: false
})
export class FilterUniqueQuestionPipe implements PipeTransform {
	transform(value: any): any{
		if(value!== undefined && value!== null){
			return _.uniqBy(value, 'question');
		}
		return value;
	}
}